import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { colorPicker } from "../common";
import { buttonStyles, cardStyles, textStyles } from "../styles";

//TODO currently not printing first record.

export const HomeDeckCard = props => {
    const cards = cardStyles();
    const buttons = buttonStyles();
    const texts = textStyles();

    if (props.length === 0) {
        return (
        <Link
            to={{
                pathname: "/createDeckScreen"
            }}
        >
            <IconButton
                className={clsx(
                    buttons.homeDeckButton,
                    colorPicker(props.buttonColor)
                )}
                aria-label="add"
            >
            <Grid container>
                <Grid item xs={12}>
                <AddIcon className={buttons.deckButtons} />
                </Grid>
                <Grid item xs={12}>
                <Typography
                    className={clsx(props.textColor, texts.homeDeckCardsText)}
                    variant={props.headerSize || "h6"}
                    align={props.headerAlign || "center"}
                    display={props.display || "initial"}
                    gutterBottom={props.gutterBottom || true}
                    noWrap={props.noWrap || false}
                    paragraph={props.paragraph || true}
                >
                    Create Deck
                </Typography>
                </Grid>
            </Grid>
            </IconButton>
        </Link>
        );
    } else {
        if (Number(props.index) === -1) {
            return (
                <>
                    <Link
                        to={{
                            pathname: "/createDeckScreen"
                        }}
                    >
                        <IconButton
                            className={clsx(
                                buttons.homeDeckButton,
                                colorPicker(props.buttonColor)
                            )}
                            aria-label="add"
                        >
                        <Grid container>
                            <Grid item xs={12}>
                            <AddIcon className={buttons.deckButtons} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    className={clsx(props.textColor, texts.homeDeckCardsText)}
                                    variant={props.headerSize || "h6"}
                                    align={props.headerAlign || "center"}
                                    display={props.display || "initial"}
                                    gutterBottom={props.gutterBottom || true}
                                    noWrap={props.noWrap || false}
                                    paragraph={props.paragraph || true}
                                >
                                    Create Deck
                                </Typography>
                            </Grid>
                        </Grid>
                        </IconButton>
                    </Link>
                </>
            );
        } else {
            let __uri = props.flashcard ? "/showFlashCard" : "/questionScreen";
            let _obj = {
                pathname: __uri,
                gameMode: props.gamemode ? props.gamemode : 3
            }

            if (props.flashcard) {
                _obj.deckid = props.deckID;
                _obj.year = 0;
            } else {
                _obj.deckID = props.deckID;
            }

            if (props.totalQs === 0) {
                _obj.pathname = '/home';
                return null
            }

            return (
                <>
                    <Link
                        to={_obj}
                    >
                        <IconButton
                            className={clsx(
                            buttons.homeDeckButton,
                            colorPicker(props.buttonColor),
                            buttons.homeCustomDeckButtons
                            )}
                            aria-label="add"
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography
                                        className={clsx(
                                            colorPicker(props.textColor),
                                            texts.homeDeckCardsText
                                        )}
                                        variant={props.headerSize || "h6"}
                                        align={props.headerAlign || "center"}
                                        display={props.display || "initial"}
                                        gutterBottom={props.gutterBottom || true}
                                        noWrap={props.noWrap || false}
                                        paragraph={props.paragraph || true}
                                    >
                                    {props.deckName || `Deck ${props.index}`}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </IconButton>
                    </Link>
                </>
            );
        }
    }
};
